import React, { useEffect } from "react";
import { Form, Input, Select } from 'antd';
import FormItem from "components/fields/FormItem";
import { connect } from "react-redux";
import { 
	getHolidayDetails, doHolidayCreate, doHolidayUpdate 
} from "../../../../../redux/holiday/holidayState";
import CrudButtons from "components/button/crudbuttons";
import { requiredField } from "utils/crudSagaHelper";
import { getLabel } from "utils";
import SwitchField from "components/fields/SwitchField";
import SelectDate from "components/fields/SelectDate";

const HolidayForm = ({
	recordData,
	getDetails,
	doCreate, 
	doUpdate, 
	onCancel,
	submitLabel,
	getRecord,
	...props
}) => {
	
  	const [form] = Form.useForm();
	const { recordId, mode } = props;  	

	useEffect(() => {
		if(recordId){
			getRecord(recordId);
		}
	}, [recordId, getRecord]);

	useEffect(() => {
		if(recordData){
			form.resetFields();
			const { holiday:hol_name, hol_type_id, ...rest } = recordData;

			const initialValues = {
				...rest,
				hol_id: recordData?.hol_id ?? "",
				hol_name: recordData?.hol_name ?? "",
			    hol_type_id: recordData?.hol_type_id ?? "",
				hol_month: recordData?.hol_month ?? undefined,
				hol_day: recordData?.hol_day ?? undefined,
				hol_is_recurring: recordData?.hol_is_recurring ?? null,
			};	
	        form.setFieldsValue(initialValues);

        }
    }, [recordData, form]);


  	const onSubmit = (formData) => {	
		console.log(formData);
    	try {  
			formData.hol_is_recurring = Number(Boolean(formData.hol_is_recurring));

			recordData.hol_id > 0 ? doUpdate(formData): doCreate(formData); 
    	} catch (error) {
      		console.error('Save failed:', error);
    	}
  	};
  
  	return (
    	<Form className={mode !== "view" ? "form" : ""}
			form={form} 
			layout="vertical"
			onFinish={onSubmit}
		>   
			<FormItem
				name="hol_id"
				hidden
			>
				<Input type="hidden"/>
			</FormItem>
			<div className="grid grid-cols-3 gap-y-2 gap-x-4 w-full">         		            	            
				<FormItem className="font-medium mb-2"
					name="hol_name"
					label="Holiday Name"
					rules={[requiredField]}
					
				>
					{mode === 'edit' ?
						<Input id="hol_name"
							className="input-field"
							maxLength={100}
							placeholder="Enter holiday name"
						/>
						: 
						<label className="text-base label-value dark:text-white">
							{recordData?.hol_name}
						</label>
					}
				</FormItem>	  
				<FormItem className="font-medium mb-2 "
					name="hol_type_id"
					label="Type"
					rules={[requiredField()]}
				>
					{mode !== 'view' ?
						<Select id="hol_type_id"
							className="input-field"
							showSearch
							allowClear={true}
							options={recordData?.holidayTypeList}
						/>
						: 
						<label className="text-base label-value dark:text-white">
							{getLabel(recordData?.holidayTypeList, recordData?.hol_type_id)}
						</label>
					}	                
				</FormItem> 
				<FormItem
					label="Country"
					name="hol_country_id"
					rules={[requiredField()]}
				>
					{mode !== "view" ? 
						<Select id="hol_country_id"
							className="input-field"
							showSearch
							allowClear={true}
							options={recordData?.countryList}
						/>
						: 
						<label className="text-base label-value dark:text-white">
							{getLabel(recordData?.countryList, recordData?.hol_country_id)}
						</label>
					}
				</FormItem>

				<SelectDate 
					form={form}
					mode={mode}
					recordData={recordData}
					monthName="hol_month"
					dayName="hol_day"
					label="Date"
				/>
				
				<FormItem 
					label="Is Recurring"
					name="hol_is_recurring"
				>
					{mode !== "view" ?
						<SwitchField
							id="hol_is_recurring"
							mode="edit"
							type="text"
							labelYes="Yes"
							labelNo="No"
						/>
						: 
						<label className="text-base label-value dark:text-white">
							{recordData?.hol_is_recurring}
						</label>
					}
				</FormItem>
			</div>


			<div className="w-full flex justify-end">
				{(mode === "edit") && (
					<CrudButtons
					mode={mode}
					recordId={recordData?.hol_id ?? 0}
					isModal={true}
					modalId={recordData?.hol_id > 0 ? 'edit_holiday' : 'add_holiday'}
					cancelLabel="Cancel"
					doHideModal={onCancel}
					submitLabel={submitLabel}
					/>
				)}
			</div> 				 			
		</Form>	 	
  	);
};

const mapStateToProps = (state) => ({
  	recordData: state.holiday.holidayDetails?.data,
});

const mapDispatchToProps = (dispatch) => ({
	getRecord: (id) => dispatch(getHolidayDetails(id)),
  	doCreate: (data) => dispatch(doHolidayCreate(data)),
  	doUpdate: (data) => dispatch(doHolidayUpdate(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(HolidayForm);
